import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/design/design/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import { Box, Text, Link } from '@primer/react';
import { LinkExternalIcon, DownloadIcon } from '@primer/octicons-react';
import OctovisualsBanner from './images/octovisuals.png';
import './octovisuals.css';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h3>{`Octovisuals are GitHub's internal set of logos and visuals for brand and marketing usage.`}</h3>
    <br />
    <p>{`GitHub's brand is visually expressed in a multitude of ways depending on the project, audience, and more. We use various brand assets, such as Octovisuals, to represent different aspects of GitHub. `}<strong parentName="p">{`Octovisuals are intended for internal use only and can only be accessed by Github staff.`}</strong></p>
    <p>
  <a href="https://octovisuals.github.com/" target="_blank">
    See the full set of Octovisuals here
  </a>
  &nbsp;
  <LinkExternalIcon size={16} fill="#0969da" mdxType="LinkExternalIcon" />
  &nbsp;&nbsp;<span style={{
        "color": "#6E7781"
      }}>(GitHub staff only)</span>
    </p>
    <br />
    <Box as="img" src={OctovisualsBanner} sx={{
      width: '100%'
    }} alt="Octovisuals" mdxType="Box" />
    <hr />
    <h3>{`Permitted GitHub logos`}</h3>
    <br />
    <Box className="octovisual_assets" mdxType="Box">
  <Box sx={{
        margin: '0px 24px 32px 24px',
        border: '1px solid #d0d7de',
        borderTopRightRadius: '3px',
        borderTopLeftRadius: '3px',
        borderBottomRightRadius: '6px',
        borderBottomLeftRadius: '6px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column'
      }} mdxType="Box">
    <div style={{
          height: 200,
          display: 'flex',
          alignItems: 'center'
        }}>
      <img width="200" height="52" src="https://github.githubassets.com/images/modules/logos_page/GitHub-Logo.png" alt="GitHub Logotype" style={{
            "height": "auto"
          }} />
    </div>
    <a style={{
          borderTop: '1px solid #d0d7de',
          backgroundColor: '#f6f8fa',
          padding: '16px',
          width: '100%',
          textAlign: 'center',
          textDecoration: 'none'
        }} href="https://github-media-downloads.s3.amazonaws.com/GitHub-Logos.zip">
      <DownloadIcon size={16} fill="rgb(87,96,106)" mdxType="DownloadIcon" /> Download GitHub logo
    </a>
  </Box>
  <Box sx={{
        margin: '0px 24px 32px 24px',
        border: '1px solid #d0d7de',
        borderTopRightRadius: '3px',
        borderTopLeftRadius: '3px',
        borderBottomRightRadius: '6px',
        borderBottomLeftRadius: '6px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column'
      }} mdxType="Box">
    <img width="200" height="200" src="https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png" alt="GitHub Logomark" style={{
          "height": "auto"
        }} />
    <a style={{
          borderTop: '1px solid #d0d7de',
          backgroundColor: '#f6f8fa',
          padding: '16px',
          width: '100%',
          textAlign: 'center',
          textDecoration: 'none'
        }} href="https://github.githubassets.com/images/modules/logos_page/github-mark.zip">
      <DownloadIcon size={16} fill="rgb(87,96,106)" mdxType="DownloadIcon" /> Download Invertocat logo
    </a>
  </Box>
    </Box>
    <h3>{`Best practices`}</h3>
    <h4>{`Do`}</h4>
    <ul>
      <li parentName="ul">{`Use a permitted GitHub logo to link to GitHub.`}</li>
      <li parentName="ul">{`Use the Invertocat logo as a social button to link to your GitHub profile or project.`}</li>
      <li parentName="ul">{`Use a permitted GitHub logo to inform others that your project integrates with GitHub.`}</li>
      <li parentName="ul">{`Use the GitHub logo in a blog post or news article about GitHub.`}</li>
      <li parentName="ul">{`Use the permitted GitHub logos less prominently than your own company or product name or logo.`}</li>
    </ul>
    <h4>{`Don't`}</h4>
    <ul>
      <li parentName="ul">{`Do not use the GitHub name or any GitHub logo in a way that suggests you are GitHub, your offering or project is by GitHub, or that GitHub is endorsing you or your offering or project.`}</li>
      <li parentName="ul">{`Do not use any GitHub logo as the icon or logo for your business/organization, offering, project, domain name, social media account, or website.`}</li>
      <li parentName="ul">{`Do not modify the permitted GitHub logos, including changing the color, dimensions, or combining with other words or design elements.`}</li>
      <li parentName="ul">{`Do not use GitHub trademarks, logos, or artwork without GitHub’s prior written permission.`}</li>
    </ul>
    <h4>{`Legal`}</h4>
    <p>{`In short, the GitHub logos represent only GitHub and should not be used to represent you or your projects, products, or company`}</p>
    <p>{`GITHUB®, the GITHUB® logo design, the INVERTOCAT logo design, OCTOCAT®, and the OCTOCAT® logo design are trademarks of GitHub, Inc., registered in the United States and other countries.`}</p>
    <p>{`The OCTOCAT design is the exclusive property of GitHub, Inc and has been federally registered with the United States Copyright Office. All rights reserved.`}</p>
    <p>{`No adaptation or use of any kind of any of our registered trademarks or copyrights, or any other contents of this website, is allowed without the express written permission of GitHub, Inc.`}</p>
    <p>{`For more information regarding the authorized uses of these items, please `}<a parentName="p" {...{
        "href": "https://support.github.com/?tags=dotcom-direct"
      }}>{`contact us`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      